export enum NotificationType {
  "download" = "download",
}

export enum NotificationStatus {
  "read" = "read",
  "unread" = "unread",
}

export interface INotification {
  id: string;
  title: string;
  description: string;
  type: NotificationType;
  status: NotificationStatus;
  owner: string;
  companyId: string;
  createdAt: string;
  data: string;
  metadata?: {
    key?: string;
  }
}
